/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
import { Component, Injector, inject, ChangeDetectionStrategy, output } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NEVER, merge } from 'rxjs';

import { SelectChangeEvent, SelectModule } from '@openng/optimus-ui/select';
import { ControlValueAccessorConnectorComponent } from '../control-value-accessor.connector';
import { BaseFormControlDirective, BaseFormControlDirectiveInputs } from '../directives/base-form-control.directive';
import {
  DropdownFormControlDirective,
  DropdownFormControlDirectiveInputs,
  DropdownFormControlDirectiveOutputs,
} from '../directives/dropdown-form-control.directive';
import {
  SelectFormControlDirective,
  SelectFormControlDirectiveInputs,
} from '../directives/select-form-control.directive';
import { FormFieldUniqNames } from '../form-fields-uniq-names.service';
import { FormComponent } from '../form/form.component';
import { FormConnectorService } from '../forms.utils';

import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';
import { TooltipModule } from '@openng/optimus-ui/tooltip';
import { uniqueId } from '@shared/utils';

export enum DropdownState {
  Closed = 'closed',
  Opened = 'opened',
}

export type SelectOption = {
  id: unknown;
  label: string;
};

@Component({
  selector: 'ui-select',
  templateUrl: './select.component.html',
  // vzhled (barvy, výška, chyba, stavy) nese gov-theme (.p-select), chybu libs/shared/ui/validace.css
  host: { class: 'block mb-4' },
  imports: [ReactiveFormsModule, FormsModule, SelectModule, InputWrapperComponent, TooltipModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectComponent,
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [
    {
      directive: BaseFormControlDirective,
      inputs: BaseFormControlDirectiveInputs,
    },
    {
      directive: SelectFormControlDirective,
      inputs: SelectFormControlDirectiveInputs,
    },
    {
      directive: DropdownFormControlDirective,
      inputs: DropdownFormControlDirectiveInputs,
      outputs: DropdownFormControlDirectiveOutputs,
    },
  ],
})
export class SelectComponent extends ControlValueAccessorConnectorComponent {
  private uniqNames = inject(FormFieldUniqNames);
  private _form = inject(FormComponent, { optional: true, skipSelf: true });
  protected _formConnectorService = inject(FormConnectorService, { optional: true, skipSelf: true });

  readonly handleChange = output<SelectChangeEvent>();

  submitted = false;
  internalName: string;
  dropdownState = DropdownState;
  randomInputId = uniqueId();

  base = inject(BaseFormControlDirective);
  select = inject(SelectFormControlDirective);
  dropdown = inject(DropdownFormControlDirective);

  constructor() {
    const injector = inject(Injector);

    super(injector, { change: false });
    this.internalName = this.uniqNames.getSelectName();

    merge<boolean[]>(this._formConnectorService?.submitted$ ?? NEVER, this._form?.getSubmitted() ?? NEVER)
      .pipe(takeUntilDestroyed())
      .subscribe((_) => (this.submitted = _));
  }
}
